<template>
  <font-awesome-icon :icon="name" />
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCalendarAlt,
  faCalendarPlus,
  faSquare,
  // faHeart,
} from '@fortawesome/free-regular-svg-icons'
import {
  faUser,
  faBars,
  faTimes,
  faExternalLinkAlt,
  faStream,
  faCheckSquare,
  faHeart,
  faSearch,
} from '@fortawesome/free-solid-svg-icons'
import {
  faFacebookF,
  faTwitter,
  faLinkedinIn,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faUser,
  faBars,
  faTimes,
  faCalendarAlt,
  faCalendarPlus,
  faExternalLinkAlt,
  faStream,
  faSquare,
  faCheckSquare,
  faFacebookF,
  faTwitter,
  faLinkedinIn,
  faYoutube,
  faHeart,
  faSearch,
  require('@fortawesome/free-regular-svg-icons/faHeart').definition
)

export default {
  components: { FontAwesomeIcon },
  props: {
    name: {
      type: [String, Array],
      required: true,
    },
  },
}
</script>

<style>
.bg-main {
  color: main_color;
}
</style>
